import HtmlParser from 'html-react-parser';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';
import Helmet from 'react-helmet';
import ReactPlayer from 'react-player';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import { DemoFormShort } from '../../components/DemoFormShort.jsx';
import JoinHappyCustomers from '../../components/JoinHappyCustomers';
import MultimedialPanel from '../../components/MultimedialPanel';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import '../../scss/pages/_compensation.scss';

class TypeWriter extends React.Component {
	componentDidMount() {		
		var elements = document.getElementsByClassName('typewrite');
		for (var i = 0; i < elements.length; i++) {
			var toRotate = elements[i].getAttribute('data-type');
			var period = elements[i].getAttribute('data-period');
			if (toRotate) {
				new TxtType(elements[i], JSON.parse(toRotate), period);
			}
		}		
	}
	render() {
		return (
			<span className="typewrite" data-period="2000" data-type='[ "streamlined", "approved", "automated", "centralized", "analyzed" , "distributed", "understood"]'>
			</span>
		);
	}
}

var TxtType = function (el, toRotate, period) {
	this.toRotate = toRotate;
	this.el = el;
	this.loopNum = 0;
	this.period = parseInt(period, 10) || 2000;
	this.txt = '';
	this.tick();
	this.isDeleting = false;
};

TxtType.prototype.tick = function () {
	var i = this.loopNum % this.toRotate.length;
	var fullTxt = this.toRotate[i];

	if (this.isDeleting) {
		this.txt = fullTxt.substring(0, this.txt.length - 1);
	} else {
		this.txt = fullTxt.substring(0, this.txt.length + 1);
	}

	this.el.innerHTML = '<span class="wrap">' + this.txt + '</span>';

	var that = this;
	var delta = 200 - Math.random() * 100;

	if (this.isDeleting) { delta /= 2; }

	if (!this.isDeleting && this.txt === fullTxt) {
		delta = this.period;
		this.isDeleting = true;
	} else if (this.isDeleting && this.txt === '') {
		this.isDeleting = false;
		this.loopNum++;
		delta = 500;
	}

	setTimeout(function () {
		that.tick();
	}, delta);
};

function WistiaPopup() {
	const [modalShow, setModalShow] = React.useState(false);
	const handleModalClose = () => setModalShow(false);
	const handleModalShow = () => setModalShow(true);

	return (
		<div className="d-flex mt-1 mb-1">
			<Button variant="" onClick={handleModalShow} className="cta cta-video">Watch short video</Button>

			<Modal show={modalShow} onHide={handleModalClose} centered>
				<Modal.Header closeButton></Modal.Header>
				<Modal.Body>
					<ResponsiveEmbed aspectRatio="16by9">
						<ReactPlayer
							url='https://charthop.wistia.com/medias/iqt7876aev'
							playing
							volume={1}
							controls={false}
							width='100%'
							height='100%'
						/>
					</ResponsiveEmbed>
				</Modal.Body>
			</Modal>
		</div>
	);
}

const Home = (props) => {

    const location = props.location;

    return (
        <Layout bodyClass="compensation" ontouchstart>
            <SEO title="Compensation Management | ChartHop | The Org Management Platform" />
            <Helmet>
                <meta
                    name="description"
                    content="Power unbiased compensation cycles with approval workflows and centralized performance, demographic and benchmark data."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Compensation Management | ChartHop | The Org Management Platform" />
                <meta property="og:description" content="Power unbiased compensation cycles with approval workflows and centralized performance, demographic and benchmark data." />
                <meta property="og:image" content={`https://www.charthop.com/product/compensation/compensation-meta-image.gif`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Compensation Management | ChartHop | The Org Management Platform" />
                <meta name="twitter:description" content="Power unbiased compensation cycles with approval workflows and centralized performance, demographic and benchmark data." />
                <meta name="twitter:image" content={`https://www.charthop.com/product/compensation/compensation-meta-image.gif`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>            

            {/* HERO CONTENT */}
            <section className="hero-formNoImage sectionSpacing">
                <div className="introContent">
                    <div className="introTitle">
                        <h1>Your compensation reviews <TypeWriter /><span className="blinking-cursor">|</span></h1>
                        <h1>- in one platform.</h1>
                    </div>
                    <DemoFormShort source="product-compensation-demo-header" />
                    <WistiaPopup />
                </div>
            </section>

            {/* HR Data */}
            <section className="sectionSpacing backgroundGradientContainer">
                <h2 className="text-center mt-2 sectionSpacing-Margin">Run your comp cycle with context and without the stress.</h2>
                <h4 className="text-center mt-0 sectionSpacing-Margin">Centralize people data and manage access within one platform - free of spreadsheets. </h4>
                <div className="contentBlock">
					<div className="svg-info">
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/time.svg'} alt="Build" />
							<h3>Build it in minutes</h3>
							<p>Say goodbye to weeks of wasted time gathering data.</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/work.svg'} alt="Customize" />
							<h3>Personalize at scale</h3>
							<p>Give each manager the right data and guidelines for their org.</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/security/role.svg'} alt="Control" />
							<h3>Keep data secure</h3>
							<p>Ensure no one has access to data they shouldn't see.</p>
						</div>
					</div>
				</div>
            </section>
            
            {/* HR Data */}
            <section className="sectionSpacing pt-7 pb-2" id="hr-data">
                <h2 className="text-center pb-lg-2 pb-5">All of the power of spreadsheets, none of the pain.</h2>
				<div className="contentBlock pb-lg-1 pb-7">
                    <MultimedialPanel 
                        multimediaPosition="right"
                        title="Create smart eligibility rules"
                        link="/product/compensation/eligibility_640.mp4"
                        type="video"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Leverage any of your people data through direct integrations with your HRIS, equity management systems, performance management systems and more.</p>
                                <p>Define eligibility rules based on anything from start date to location to performance data.</p>
                            </React.Fragment>
                        }
                    />
				</div>

                <div className="contentBlock pb-lg-1 pb-7">
                    <MultimedialPanel 
                        multimediaPosition="left"
                        title="Provide guidelines & benchmarks"
                        link="/product/compensation/guides.mp4"
                        type="video"
                        paddingClass="padding-top-video-three"
                        content={
                            <React.Fragment>
                                <p>Empower managers with clear guidelines and benchmarks built directly within the review flow.</p>
                                <p>Automatically flag any proposal that falls out of the recommended range and request additional information.</p>
                            </React.Fragment>
                        }
                    />					
				</div>

                <div className="contentBlock pb-lg-1 pb-7">
                    <MultimedialPanel 
                        multimediaPosition="right"
                        title="Allocate budget effectively"
                        link="/product/compensation/bugdet-allocation.mp4"
                        type="video"
                        paddingClass="padding-top-video-four"
                        content={
                            <React.Fragment>
                                <p>Seamlessly distribute budget throughout the organization.</p>
                                <p>Define and recalibrate budgets as needed - either as percentage of total headcount or as a monetary amount.</p>
                            </React.Fragment>
                        }
                    />					
				</div>
			</section>

            <section className="sectionSpacing backgroundGradientContainer">
                <div className="contentBlock">
                    <h2 className="text-center mt-2 sectionSpacing-Margin">Identify and rectify inequalities before they go into effect.</h2>
                    <h4 className="text-center mt-0 sectionSpacing-Margin">Give managers, approvers, HR and leaders the ability to analyze the impact of proposed changes across any dimension.</h4>
					<div className="pgc1">
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Raises by Performance Review</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Promotions by Performance Review</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Performance Review by Gender</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Performance Review by Race/Ethnicity</p>
                            </div>
                        </div>
                    
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Raises by Gender or Race</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Promotions by Gender or Race</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Span of Control by Gender or Race</p>
                            </div>
                        </div>
                        <div className="pgc2">
                            <div className="pgc3">
                                <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                <p>Time to promotion by Gender or Race</p>
                            </div>
                        </div>
                    </div>
					<p className="subListTitle font-weight-bold text-center">& more</p>
				</div>
            </section>



            {/* Analyze */}
            <section className="sectionSpacing pt-7 pb-2" id="analyze">
                <h2 className="text-center pb-lg-2 pb-5">Empower every layer of your org with streamlined workflows.</h2>
				<div className="contentBlock pb-lg-1 pb-7">
                    <MultimedialPanel 
                        multimediaPosition="right"
                        title="Approve proposals in one click"
                        link="/product/compensation/approvals.mp4"
                        type="video"
                        paddingClass="padding-top-video-five"
                        content={
                            <React.Fragment>
                                <p>Forget about the emails and slacks - centralize all approvals and keep everyone on the same page.</p>
                            </React.Fragment>
                        }
                    />
				</div>

				<div className="contentBlock pb-lg-1 pb-7">
                    <MultimedialPanel 
                        multimediaPosition="left"
                        title="Understand the impact at every level"
                        link="/product/compensation/reporting.mp4"
                        type="video"
                        paddingClass="padding-top-video-six"
                        content={
                            <React.Fragment>
                                <p>Visualize how the proposed changes will affect metrics across your organization - from total cost by department to average raise by gender.</p>
                            </React.Fragment>
                        }
                    />
				</div>

                <div className="contentBlock pb-lg-1 pb-7">
                    <MultimedialPanel 
                        multimediaPosition="right"
                        title="Easily consolidate proposals"
                        link="/product/compensation/consolidation.mp4"
                        type="video"
                        paddingClass="padding-top-video-seven"
                        content={
                            <React.Fragment>
                                <p>Roll up proposed changes up the chain of command with the click of a button.</p>
                            </React.Fragment>
                        }
                    />
				</div>
			</section>

            

            {/* AVAILABLE INTEGRATIONS */}
            <section className="backgroundGradientContainer-Reverse sectionSpacing  integrations">
                <h2 className="text-center mt-0 sectionSpacing-Margin">Let's move beyond the manual spreadsheets.</h2>           
                <h4 className="text-center mt-0 sectionSpacing-Margin">Integrate your existing systems in minutes and roll out the comp cycle you've always wanted.</h4>
                <div className="moreIntegrationsContent">
                    <div className="floating-minorCardContainer">
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-bamboo@2x.jpg' alt="BambooHR" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-slack@2x.jpg' alt="Slack" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-workday@2x.jpg' alt="Workday" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-successfactors@2x.jpg' alt="Success Factors" />
                            </div>
                        </div>
                        {/* FIRST 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-greenhouse@2x.jpg' alt="Greenhouse" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-lever@2x.jpg' alt="Lever" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-carta@2x.jpg' alt="Carta" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-e-trade@2x.jpg' alt="E-Trade" />
                            </div>
                        </div>

                        {/* SECOND 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-trinet@2x.jpg' alt="Trinet" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/gusto.png' alt="Gusto" /> 
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-rippling@2x.jpg' alt="Rippling" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-justworks@2x.jpg' alt="Justworks" />
                            </div>
                        </div>

                        {/* THIRD 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/sequoia.png' alt="Sequoia" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-paylocity@2x.jpg' alt="Paylocity" />
                            </div>
                        </div>
                        
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-namely@2x.jpg' alt="Namely" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/zenefits.png' alt="Zenefits" />
                            </div>
                        </div>                     

                        {/* pseudo */}
                        <div className="psudeo ps1">
                        </div>

                        <div className="psudeo ps2">
                        </div>

                        <div className="psudeo ps3">
                        </div>

                        <div className="psudeo ps4">
                        </div>

                        {/* more */}
                        <h4 className="text-center">& more</h4>
                    </div>
                </div>
            </section>

            {/* customers */}
            <section className="customer testimonial-container pt-8 pb-5">
                <JoinHappyCustomers title={HtmlParser('Join our <span class="blue-text">hoppy</span> customers')}></JoinHappyCustomers>
            </section>

            {/* LONG FORM */}
            <section name="request-demo" id="request-demo" className="request-demo request-demo-white pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"product-compensation-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">“Before, our compensation planning would have been completely manual using spreadsheets. Using ChartHop, we completed our global review in three weeks.</br></br>This was the first time we were able to provide a secure, standardized, and integrated tool for managers and leaders to plan and view their team members’ information in aggregate.” </p><div class="authorTag"><img src="/home/quotes/ray-anderson-peloton.jpeg" class="testimonialAuthor" alt="Ray Anderson" /><div><p class="contactAuthor"><strong>Ray Anderson</strong> <br>People Systems & Analytics<br><img src="/home/brand_logos/peloton-logo.svg" alt="Peloton" class="MongoDBauthor" /></p></div></div>')}/>
			</section>
        </Layout>
    );
};


export default Home;
